import { render, staticRenderFns } from "./EofyModal.vue?vue&type=template&id=7823b12f&"
import script from "./EofyModal.vue?vue&type=script&lang=js&"
export * from "./EofyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports